var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 8.25H10.5833C9.57081 8.25 8.75 9.07081 8.75 10.0833V18.3333C8.75 19.3459 9.57081 20.1667 10.5833 20.1667H18.8333C19.8459 20.1667 20.6667 19.3459 20.6667 18.3333V10.0833C20.6667 9.07081 19.8459 8.25 18.8333 8.25Z",
    stroke: "#FFFDFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08325 13.75H4.16659C3.68036 13.75 3.21404 13.5568 2.87022 13.213C2.52641 12.8692 2.33325 12.4029 2.33325 11.9166V3.66665C2.33325 3.18042 2.52641 2.7141 2.87022 2.37028C3.21404 2.02647 3.68036 1.83331 4.16659 1.83331H12.4166C12.9028 1.83331 13.3691 2.02647 13.7129 2.37028C14.0568 2.7141 14.2499 3.18042 14.2499 3.66665V4.58331",
    stroke: "#FFFDFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy_white.c6b2555bbdd153fbb57b768014d4160a.svg";
export { ForwardRef as ReactComponent };